if (!window.sdCollectionTeaserReady) {
  window.sdCollectionTeaserReady = true;
  const initialiseTeasers = (root = document) => {
    root.querySelectorAll('[data-sd-collection-teaser]').forEach((container) => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      const text = container.querySelector('p');
      const button = container.querySelector('button');
      if (!text || !button) return;
      const update = () => {
        const lineHeight = Number.parseFloat(getComputedStyle(text).lineHeight);
        const hasMore = text.scrollHeight > lineHeight * 3 + 1;
        button.hidden = !hasMore;
        if (!hasMore) {
          container.dataset.expanded = 'false';
          button.setAttribute('aria-expanded', 'false');
          button.textContent = button.dataset.more;
        }
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        container.dataset.expanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
      new ResizeObserver(update).observe(text);
      document.fonts?.ready.then(update);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseTeasers(), { once: true });
  } else {
    initialiseTeasers();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseTeasers(event.target));
}
